import React from 'react';

import { BrailleSymbol } from '../../../components';
import { translate } from '../../../translator';

interface ReferenceSectionProps {
  symbols: string[];
  heading: string;
}

export const ReferenceSection = ({ symbols, heading }: ReferenceSectionProps) => (
  <div className="flex flex-col">
    <div className="prose">
      <h3 className="m-4">{heading}</h3>
    </div>
    <ul className="flex flex-wrap">
      {symbols.map((symbol) => (
        <div key={symbol} className="pr-8 pb-8">
          <BrailleSymbol input={translate(symbol, { ignorePrefix: true })[0]} text={symbol} />
        </div>
      ))}
    </ul>
  </div>
);
